import english from '../en/cinema';

export default {
  ...english,
  cinema_referral: "Dapatkan dengan Berkongsi",
  cinema_referralDesc: "Jemput rakan melalui pautan peribadi anda dan dapatkan ganjaran",
  cinema_referralLinkTitle: "Pautan Rujukan Saya",
  cinema_referralLinkDesc: "Pendaftaran baharu melalui pautan ini akan dikaitkan kepada anda",
  cinema_referralRulesTitle: "Peraturan Rujukan",
  cinema_referralRulesCoins: "Apabila seorang rakan mendaftar melalui pautan rujukan anda, anda mungkin menerima ganjaran syiling. Syiling hanya boleh digunakan untuk menonton kandungan di platform dan tidak boleh ditukar menjadi wang tunai atau dikeluarkan.",
  cinema_referralRulesCommission: "Apabila seorang rakan membuat pengisian semula, anda mungkin memperoleh komisen mengikut peraturan yang berkenaan. Hanya komisen pengisian semula yang boleh dikeluarkan; apabila jumlahnya mencapai ¥100, anda boleh memohon pengeluaran dalam bentuk USDT.",
  cinema_copyLink: "Salin pautan",
  cinema_inviteCodeLabel: "Kod rujukan",
  cinema_inviteRuleTitle: "Ganjaran rujukan",
  cinema_inviteRuleNormal: "Ahli mendapat 20 syiling bagi setiap pendaftaran berjaya. Ganjaran direkodkan dalam sejarah syiling.",
  cinema_distributorOverview: "Gambaran keseluruhan pengedar",
  cinema_availableCommission: "Tersedia",
  cinema_totalCommission: "Jumlah komisen",
  cinema_pendingWithdrawal: "Pengeluaran tertunggu",
  cinema_withdrawnAmount: "Telah dikeluarkan",
  cinema_firstLevelRate: "Kadar tahap 1",
  cinema_secondLevelRate: "Kadar tahap 2",
  cinema_todayBrowse: "Tontonan",
  cinema_todayRegister: "Pendaftaran",
  cinema_todayRecharge: "Pengisian semula",
  cinema_todayRechargeAmount: "Jumlah pengisian semula",
  cinema_commissionAmount: "Komisen",
  cinema_registerDetails: "Pendaftaran",
  cinema_rechargeDetails: "Pengisian semula",
  cinema_inviteRewards: "Ganjaran rujukan",
  cinema_goWithdraw: "Pengeluaran",
  cinema_noReferralData: "Tiada data rujukan lagi",
  cinema_referralLoadFailed: "Gagal memuatkan data rujukan. Sila cuba lagi.",
  cinema_loginToPromote: "Daftar masuk untuk mencipta pautan rujukan anda",
  cinema_totalEarnings: "Jumlah Pendapatan",
  cinema_withdrawable: "Boleh dikeluarkan",
  cinema_frozen: "Dibeku",
  cinema_invitedCount: "Dijemput",
  cinema_coinUnit: "syiling",
  cinema_people: "orang",
  cinema_conversionStats: "Konversi Rujukan",
  cinema_allDatesTotal: "Jumlah semua tarikh",
  cinema_selectedDatesTotal: "Jumlah tarikh yang dipilih",
  cinema_conversionStatsDesc: "Tontonan harian, pendaftaran, pengisian semula dan komisen",
  cinema_colDate: "Tarikh",
  cinema_colPv: "Pelawat",
  cinema_colBrowseCount: "Tontonan",
  cinema_colRegister: "Pendaftaran",
  cinema_colRechargeUsers: "Pembayar",
  cinema_colRechargeOrders: "Pesanan",
  cinema_colPaidAmount: "Jumlah Dibayar",
  cinema_colCommission: "Komisen",
  cinema_colRegisterRate: "Kadar Pendaftaran",
  cinema_colRechargeRate: "Kadar Pengisian Semula",
  cinema_commissionRateTitle: "Kadar Komisen",
  cinema_currentRateLabel: "Kadar komisen sebenar semasa",
  cinema_baseRate: "Kadar Asas",
  cinema_currentRate: "Kadar Semasa",
  cinema_earningsRecord: "Rekod Pendapatan",
  cinema_inviteDetail: "Butiran Jemputan",
  cinema_allEarnings: "Semua Pendapatan",
  cinema_filterAll: "Semua",
  cinema_filterPending: "Tertangguh",
  cinema_filterSettled: "Diselesaikan",
  cinema_earningsDate: "Tarikh",
  cinema_earningsType: "Jenis",
  cinema_earningsUser: "Pengguna",
  cinema_earningsAmount: "Pendapatan",
  cinema_earningsStatus: "Status",
  cinema_statusSettled: "Diselesaikan",
  cinema_statusPending: "Tertangguh",
  cinema_noEarningsRecords: "Tiada rekod lagi",
  cinema_referralUser: "Pengguna",
  cinema_referralRegDate: "Berdaftar",
  cinema_referralRecharged: "Jumlah Diisi Semula",
  cinema_referralEarned: "Pendapatan Saya",
  cinema_startDate: "Tarikh Mula",
  cinema_endDate: "Tarikh Tamat",
  cinema_query: "Cari",
  cinema_dateRangeError: "Tarikh mula tidak boleh lewat daripada tarikh tamat",
  cinema_brand: "Huangguo TV",
  cinema_language: "Bahasa",
  cinema_tagline: "Drama pendek AI asli",
  cinema_navHome: "Utama",
  cinema_navCategories: "Kedudukan",
  cinema_rankingTitle: "Kedudukan",
  cinema_rankingAll: "Semua",
  cinema_rankingLoading: "Memuatkan kedudukan...",
  cinema_rankingStats: "{{scope}} · {{period}} · {{count}} siri · {{views}} tontonan",
  cinema_rankingTotal: "Sepanjang masa",
  cinema_rankingMonth: "Bulanan",
  cinema_rankingWeek: "Mingguan",
  cinema_rankingLatest: "Terkini",
  cinema_rankingCreator: "Pencipta",
  cinema_creatorLabel: "Pencipta",
  cinema_rankingEmpty: "Tiada siri berperingkat lagi",
  cinema_navMyList: "Popular",
  cinema_soundGuideTitle: "Ketik di sini untuk menghidupkan bunyi",
  cinema_soundGuideAction: "Hidupkan bunyi",
  cinema_soundGuideDismiss: "Tidakkan panduan bunyi",
  cinema_navHistory: "Sejarah",
  cinema_navAds: "Syiling",
  cinema_adsTitle: "Iklan Tersenarai",
  cinema_adsSubtitle: "Teroka lebih banyak kandungan tersenarai",
  cinema_adFeatured: "Tersenarai",
  cinema_adOpen: "Lihat Sekarang",
  cinema_adsEmpty: "Tiada iklan tersedia",
  cinema_adsLoadFailed: "Gagal memuat iklan. Sila cuba lagi.",
  cinema_earnTitle: "Dapatkan Syiling",
  cinema_earnSubtitle: "Daftar masuk setiap hari dan kumpulkan syiling",
  cinema_earnBalance: "Syiling Saya",
  cinema_checkInTitle: "Daftar Masuk Harian",
  cinema_checkInSubtitle: "Pertahankan rentetan anda untuk mendapat lebih banyak syiling",
  cinema_checkInDay: "Hari {{day}}",
  cinema_checkInToday: "Hari Ini",
  cinema_checkInClaim: "Daftar masuk untuk {{points}} syiling",
  cinema_checkInClaimed: "Telah mendaftar masuk hari ini",
  cinema_checkInLogin: "Log masuk untuk mendaftar masuk",
  cinema_checkInSuccess: "Daftar masuk selesai. Anda telah memperoleh {{points}} syiling",
  cinema_checkInFailed: "Daftar masuk gagal. Semak sambungan anda dan cuba lagi",
  cinema_checkInNoReward: "Peranti ini telah menerima ganjaran daftar masuk hari ini",
  cinema_checkInStreak: "Rentetan semasa",
  cinema_checkInStreakValue: "{{days}} hari",
  cinema_checkInTotal: "Jumlah diperoleh",
  cinema_checkInTotalValue: "{{points}} syiling",
  cinema_checkInLoadFailed: "Gagal memuatkan status daftar masuk",
  cinema_retry: "Cuba lagi",
  cinema_moreEarnWays: "Lebih banyak cara untuk mendapatkan",
  cinema_inviteEarnTitle: "Jemput rakan dan dapatkan",
  cinema_inviteEarnDesc: "Dapatkan syiling apabila seorang rakan mendaftar",
  cinema_goInvite: "Jemput",
  cinema_earnCoinsTitle: "Dapatkan Syiling",
  cinema_earnCoinsBalance: "Syiling Saya",
  cinema_earnCoinsSignInStreak: "Anda telah membuat daftar masuk selama {{count}} hari",
  cinema_earnCoinsCheckIn: "Daftar Masuk",
  cinema_earnCoinsCheckedIn: "Telah Mendaftar Masuk",
  cinema_earnCoinsTomorrow: "Kembali Lagi Esok",
  cinema_earnCoinsInviteTitle: "Jemput seorang rakan untuk mendapat",
  cinema_earnCoinsInviteCode: "Kod Jemputan Saya",
  cinema_earnCoinsGoInvite: "Jemput Sekarang",
  cinema_earnCoinsLimitedTask: "Tugas Terhad",
  cinema_earnCoinsTimeLeft: "Masa Hitung Detik",
  cinema_earnCoinsNewbieTask: "Tugas Baru",
  cinema_earnCoinsDailyTask: "Tugas Harian",
  cinema_earnCoinsRecommendations: "Disyorkan",
  cinema_earnCoinsAdTask: "Tonton Iklan",
  cinema_earnCoinsAdTaskDesc: "Tonton iklan untuk mendapatkan lebih banyak syiling",
  cinema_earnCoinsGoWatch: "Tonton Iklan",
  cinema_earnCoinsTaskReward: "+{{reward}}",
  cinema_earnCoinsDayLabel: "Hari {{day}}",
  cinema_earnCoinsToday: "Hari Ini",
  cinema_earnCoinsCoinUnit: "syiling",
  cinema_earnCoinsAdCurrent: "Tugas Semasa",
  cinema_earnCoinsAdLocked: "Tugas Terkunci",
  cinema_earnCoinsTaskCompleted: "Selesai",
  cinema_limitedRechargeTaskTitle: "Selesaikan pengisian semula pertama anda dalam masa 1 jam",
  cinema_limitedRechargeTaskAction: "Isi Semula",
  cinema_claimReward: "Tuntut",
  cinema_claiming: "Sedang Menuntut",
  cinema_taskClaimFailed: "Tuntutan gagal. Sila cuba lagi.",
  cinema_bindEmailAction: "Ikat E-mel",
  cinema_limitedRechargeTaskExpired: "Tamat Tempoh",
  cinema_watchHistory: "Sejarah Tontonan",
  cinema_navSearch: "Cari siri...",
  cinema_login: "Log masuk",
  cinema_vip: "Tambah nilai",
  cinema_heroPlay: "Main Sekarang",
  cinema_heroMore: "Ketahui Lebih Lanjut",
  cinema_hotRecommend: "Tren Kini",
  cinema_carouselLoading: "Memuatkan kandungan unggulan...",
  cinema_newRelease: "Keluaran Baharu",
  cinema_allSeries: "Semua Siri",
  cinema_viewAll: "Lihat Semua",
  cinema_episodes: "{{count}} Episod",
  cinema_rating: "Penilaian {{score}}",
  cinema_views: "{{count}} Tontonan",
  cinema_play: "Main",
  cinema_continueWatch: "Terus Menonton",
  cinema_rewatch: "Tonton Semula",
  cinema_categoryAll: "Semua",
  cinema_categoryUrban: "Romantik Bandar",
  cinema_categorySuspense: "Suspens",
  cinema_categoryCostume: "Sejarah",
  cinema_categoryWorkplace: "Tempat Kerja",
  cinema_categorySciFi: "Sains Fiksyen",
  cinema_categorySciFiRomance: "Romantik Sains Fiksyen",
  cinema_unlock: "Buka Kunci Episod",
  cinema_unlockDesc: "Membuka kunci episod ini memerlukan {{cost}} syiling",
  cinema_unlockConfirm: "Sahkan & Main",
  cinema_cancel: "Batalkan",
  cinema_balance: "Baki: {{coins}} syiling",
  cinema_insufficient: "Syiling tidak mencukupi, sila isi semula",
  cinema_unlocked: "Dibuka",
  cinema_locked: "Dikunci",
  cinema_episodeNumber: "Episod {{number}}",
  cinema_playing: "Sedang Dimainkan",
  cinema_backToList: "Kembali ke Senarai",
  cinema_back: "Kembali",
  cinema_noSeries: "Tiada siri tersedia",
  cinema_seriesDesc: "Sinopsis",
  cinema_episodeList: "Episod",
  cinema_nextEpisode: "Seterusnya",
  cinema_episodeEnded: "Episod Tamat",
  cinema_nextEpisodePrompt: "Teruskan dengan episod {{number}}?",
  cinema_playNextEpisode: "Main Episod Seterusnya",
  cinema_prevEpisode: "Sebelumnya",
  cinema_freeLabel: "Percuma",
  cinema_vipLabel: "VIP",
  cinema_newLabel: "Baharu",
  cinema_hotLabel: "Hangat",
  cinema_featuredBanner: "Wajib Tonton Minggu Ini",
  cinema_watchNow: "Tonton Sekarang",
  cinema_searchPlaceholder: "Cari drama",
  cinema_noResults: "Tiada siri ditemui",
  cinema_emptyMyList: "Belum ada siri dalam senarai anda",
  cinema_emptyHistory: "Tiada sejarah tontonan",
  cinema_addToMyList: "Tambah ke Senarai Saya",
  cinema_removeFromMyList: "Alih keluar dari Senarai Saya",
  cinema_clearAll: "Kosongkan Semua",
  cinema_footerCopy: "Huangguo TV — Platform Drama Pendek Premium",
  cinema_footerWarning: "Kandungan dijana oleh AI untuk tujuan hiburan. Sila patuhi undang-undang tempatan.",
  cinema_myList: "Senarai Saya",
  cinema_addedAt: "Ditambah pada {{date}}",
  cinema_expand: "Kembangkan",
  cinema_collapse: "Lipat",
  cinema_historyAll: "Semua",
  cinema_historyUnfinished: "Belum Selesai",
  cinema_historyFinished: "Selesai",
  cinema_historyCount: "{{count}} rekod",
  cinema_noHistoryFilter: "Tiada rekod dalam kategori ini",
  cinema_finished: "Selesai",
  cinema_watchedFull: "Tamat",
  cinema_welcomeBack: "Selamat Kembali",
  cinema_loginDesc: "Log masuk untuk membuka lebih banyak kandungan",
  cinema_phoneLogin: "Log Masuk Melalui Telefon",
  cinema_emailLogin: "Log Masuk Melalui E-mel",
  cinema_phonePlaceholder: "Masukkan nombor telefon",
  cinema_emailPlaceholder: "Masukkan alamat e-mel",
  cinema_agreeTerms: "Dengan log masuk, anda bersetuju dengan",
  cinema_userAgreement: "Perjanjian Pengguna",
  cinema_privacyPolicy: "Dasar Privasi",
  cinema_getCode: "Dapatkan Kod",
  cinema_loginNow: "Log Masuk Sekarang",
  cinema_otherLogin: "Kaedah Log Masuk Lain",
  cinema_loggingIn: "Sedang log masuk...",
  cinema_loginSuccess: "Log Masuk Berjaya",
  cinema_loginRedirect: "Mengalihkan ke profil...",
  cinema_profile: "Profil",
  cinema_memberLabel: "Ahli",
  cinema_dealerLabel: "Pengedar",
  cinema_coinAmount: "{{count}} syiling",
  cinema_profileAccount: "Akaun",
  cinema_profileContent: "Kandungan",
  cinema_profileSettings: "Tetapan",
  cinema_editProfile: "Sunting Profil",
  cinema_myCoins: "Syiling Saya",
  cinema_myPurchases: "Dibeli",
  cinema_downloads: "Muat Turun",
  cinema_playbackSettings: "Tetapan Main Balik",
  cinema_notifications: "Pemberitahuan",
  cinema_cacheManage: "Pengurusan Cache",
  cinema_about: "Hubungi Kami",
  cinema_contactUnavailable: "Perkhidmatan pelanggan tidak tersedia. Sila cuba lagi kemudian.",
  cinema_watchedHours: "Jam Tontonan",
  cinema_collectionCount: "Koleksi",
  cinema_logout: "Keluar",
  cinema_logoutConfirm: "Sahkan Keluar?",
  cinema_logoutConfirmDesc: "Anda perlu log masuk semula untuk menggunakan semua ciri",
  cinema_version: "Versi {{version}}",
  cinema_rechargeTitle: "Isi Semula",
  cinema_rechargeSubtitle: "Pilih pelan isi semula",
  cinema_rechargeVpnWarning: "VPN atau proksi mungkin mencetuskan kawalan risiko pembayaran, menyebabkan halaman pembayaran tidak terbuka atau membuat pembayaran gagal.",
  cinema_rechargeVpnGuideTitle: "Matikan VPN anda sebelum membuat pembayaran",
  cinema_rechargeVpnInstruction: "Selepas mematikan VPN, klik butang di bawah untuk meneruskan dengan kaedah pembayaran yang dipilih.",
  cinema_rechargeVpnContinue: "VPN telah dimatikan, sambung ke pembayaran",
  cinema_rechargeRMB: "Isi Semula RMB",
  cinema_rechargeUSDT: "Isi Semula USDT",
  cinema_rechargeRecommended: "Disarankan",
  cinema_rechargeCoins: "Syiling",
  cinema_rechargeBonus: "Bonus +{{points}}",
  cinema_rechargeCredited: "Dapatkan {{points}}",
  cinema_firstRechargeBannerTitle: "Bonus isi semula pertama! Ganjaran tambahan pada sebarang amaun",
  cinema_firstRechargeSelectedBonus: "Syiling +{{points}}",
  cinema_firstRechargeLimitedTitle: "Bonus isi semula pertama terhad",
  cinema_dailyRechargeLimitedTitle: "Bonus isi semula terhad",
  cinema_firstRechargeLimitedBonus: "Tambahan {{percent}}% pada sebarang amaun",
  cinema_rechargePayMethod: "Kaedah Pembayaran",
  cinema_rechargePay: "Bayar",
  cinema_rechargeNoPackages: "Tiada pelan pengisian semula yang tersedia pada masa ini",
  cinema_paymentUnavailable: "Pembayaran pada masa ini tidak tersedia. Sila hubungi sokongan.",
  cinema_follow: "Ikuti",
  cinema_collect: "Kumpul",
  cinema_share: "Kongsi",
  cinema_loading: "Memuat...",
  cinema_favorites: "Kegemaran",
  cinema_emptyFavorites: "Belum ada siri kegemaran",
  cinema_emptyPurchases: "Belum ada siri yang dibeli",
  cinema_clearAllConfirm: "Bersihkan semua sejarah tontonan?",
  cinema_episodesUnit: "Episod",
  cinema_lastWatched: "Episod terakhir ditonton {{episode}}",
  cinema_purchasedEpisodes: "{{count}} episod telah dibuka",
  cinema_account: "Akaun",
  cinema_accountName: "Nama paparan",
  cinema_accountEmail: "E-mel",
  cinema_shareCode: "Kongsikan kod",
  cinema_saveProfile: "Simpan profil",
  cinema_profileSaved: "Profil berjaya disimpan",
  cinema_profileSaveFailed: "Gagal menyimpan profil",
  cinema_accountInfo: "Maklumat asas",
  cinema_changePassword: "Tukar kata laluan",
  cinema_newPassword: "Kata laluan baharu",
  cinema_confirmPassword: "Sahkan kata laluan baharu",
  cinema_passwordHint: "Gunakan sekurang-kurangnya 6 aksara",
  cinema_passwordMismatch: "Kata laluan tidak sepadan",
  cinema_passwordSaved: "Kata laluan berjaya dikemas kini",
  cinema_passwordSaveFailed: "Gagal mengemas kini kata laluan",
  cinema_savePassword: "Simpan kata laluan",
  cinema_pointsBalance: "Baki syiling",
  cinema_coinLedger: "Rekod syiling",
  cinema_businessReference: "Rujukan",
  cinema_emptyPointLogs: "Belum ada sejarah syiling",
  cinema_pointLog_registerReward: "Ganjaran pendaftaran",
  cinema_pointLog_appFirstLoginReward: "Ganjaran log masuk aplikasi pertama",
  cinema_pointLog_inviteReward: "Ganjaran jemputan",
  cinema_pointLog_dailyCheckIn: "Ganjaran daftar masuk harian",
  cinema_pointLog_limitedRechargeTask: "Ganjaran tugasan pengisian semula pertama terhad",
  cinema_pointLog_emailBindingTask: "Ganjaran tugasan mengikat e-mel",
  cinema_pointLog_dailyUnlockTask: "Ganjaran tugasan membuka episod harian",
  cinema_bindEmailTaskTitle: "Pautkan E-mel",
  cinema_dailyUnlockTaskTitle: "Buka {{count}} episod baharu",
  cinema_unlockAction: "Buka Kunci",
  cinema_dailyTaskProgress: "Kemajuan hari ini {{current}}/{{target}} (Episod 1 tidak dikira)",
  cinema_pointLog_firstEpisodeUnlock: "Buka kunci episod pertama",
  cinema_pointLog_episodeUnlock: "Buka kunci episod",
  cinema_pointLog_recharge: "Tambah nilai telah dikreditkan",
  cinema_pointLog_firstRechargeBonus: "Bonus tambah nilai pertama",
  cinema_pointLog_dailyRechargeBonus: "Bonus tambah nilai terhad",
  cinema_pointLog_adminAdjust: "Pelarasan pentadbir",
  cinema_pointLog_other: "Perubahan syiling",
  cinema_pointBiz_register: "Pendaftaran",
  cinema_pointBiz_registerBackfill: "Pengisian semula hadiah pendaftaran",
  cinema_pointBiz_appFirstLogin: "Log masuk aplikasi pertama",
  cinema_pointBiz_inviteRegister: "Pendaftaran yang dijemput",
  cinema_pointBiz_dailyCheckIn: "Daftar masuk harian",
  cinema_pointBiz_legacyLimitedRechargeTask: "Tugas tambah nilai 24 jam",
  cinema_pointBiz_limitedRechargeTask: "Tugas tambah nilai pertama 1 jam",
  cinema_pointBiz_emailBindingTask: "Tugas mengikat e-mel",
  cinema_pointBiz_unlockThreeEpisodes: "Tugas membuka kunci 3 episod harian",
  cinema_pointBiz_unlockFiveEpisodes: "Tugas membuka kunci 5 episod harian",
  cinema_pointBiz_episodeUnlock: "Buka kunci episod",
  cinema_pointBiz_rechargeOrder: "Pesanan tambah nilai",
  cinema_pointBiz_adminAdjust: "Pelarasan pentadbir",
  cinema_pointBiz_other: "Perniagaan lain",
  cinema_playbackAutoplay: "Mainkan episod seterusnya secara automatik",
  cinema_playbackAutoplayDesc: "Sambung secara automatik apabila satu episod tamat",
  cinema_aboutDesc: "Fantasi Saya membawakan anda kandungan drama pendek yang sentiasa dikemas kini.",
  cinema_rechargeOrders: "Rekod Tambah Nilai",
  cinema_myRechargeRecords: "Lihat rekod tambah nilai saya",
  cinema_totalInvites: "Jumlah Jemputan",
  cinema_distributionStats: "Statistik Promosi",
  cinema_distributionStatsDesc: "Semak lawatan, pendaftaran, tambah nilai dan komisen mengikut tarikh",
  cinema_summaryDate: "Tarikh",
  cinema_summaryBrowse: "Lawatan",
  cinema_summaryRegister: "Pendaftaran",
  cinema_summaryRechargeCount: "Tambah nilai",
  cinema_conversionRate: "Kadar Penukaran",
  cinema_commissionRatio: "Nisbah Komisen",
  cinema_browseDetails: "Lihat Butiran",
  cinema_browseTime: "Masa Dilihat",
  cinema_browseDrama: "Drama",
  cinema_browseRegion: "Wilayah",
  cinema_noBrowseData: "Tiada rekod lawatan lagi",
  cinema_noSummaryData: "Tiada data ringkasan lagi",
  cinema_rewarded: "Diberi ganjaran",
  cinema_registered: "Berdaftar",
  cinema_close: "Tutup",
  cinema_emptyRechargeOrders: "Tiada rekod pengisian semula lagi",
  cinema_rechargeRecords: "Buku Akaun Pengisian Semula",
  cinema_commissionRecords: "Buku Akaun Komisen",
  cinema_rechargeTime: "Masa Pengisian Semula",
  cinema_paymentMethod: "Kaedah Pembayaran",
  cinema_paymentStatus: "Status Pembayaran",
  cinema_orderNo: "Nombor Pesanan",
  cinema_noRechargeRecords: "Tiada rekod pengisian semula lagi",
  cinema_commissionTime: "Masa Komisen",
  cinema_commissionLevel: "Tahap Komisen",
  cinema_commissionRate: "Kadar Komisen",
  cinema_noCommissionRecords: "Tiada rekod komisen lagi",
  cinema_search: "Cari",
  cinema_reset: "Tetapkan Semula",
  cinema_previousPage: "Sebelumnya",
  cinema_nextPage: "Seterusnya",
  cinema_paymentStatus_created: "Dicipta",
  cinema_paymentStatus_pending: "Menunggu pembayaran",
  cinema_paymentStatus_paid: "Pengisian semula selesai",
  cinema_paymentStatus_failed: "Pembayaran gagal",
  cinema_paymentStatus_closed: "Ditutup",
  cinema_paymentStatus_expired: "Tamat tempoh",
  cinema_paymentAwaiting: "Pesanan telah dicipta. Selesaikan pembayaran di halaman pembayaran. Jika gagal, pastikan VPN anda telah dimatikan.",
  cinema_usdtAddress: "Alamat penerima",
  cinema_usdtNetwork: "Hanya rangkaian TRC20",
  cinema_copy: "Salin",
  cinema_copied: "Telah disalin",
  cinema_playerSettings: "Tetapan main balik",
  cinema_playerQuality: "Kualiti",
  cinema_playerSpeed: "Kelajuan main balik",
  cinema_playerAuto: "Automatik",
  cinema_playerSource: "Asal",
  cinema_playerSubtitles: "Sari kata",
  cinema_subtitleAuto: "Automatik",
  cinema_subtitleOff: "Matikan sari kata",
  cinema_appDownloadTitle: "Tonton episod seterusnya dengan lebih boleh dipercayai dalam Aplikasi",
  cinema_appDownloadDesc: "Ingatkan kemajuan anda dan dapatkan notifikasi tentang kemas kini.",
  cinema_appDownloadReward: "Muat turun Aplikasi dan dapatkan {{points}} syiling bonus pada log masuk pertama anda!",
  cinema_homeAppDownloadReward: "Dapatkan {{points}} syiling bonus apabila anda log masuk menggunakan Aplikasi!",
  cinema_shareEarnPoints: "Kongsi & Hasilkan",
  cinema_shareLinkLabel: "Kongsi pautan",
  cinema_shareRewardUnlimited: "Hasilkan {{points}} syiling untuk setiap pengguna baharu yang menyertai melalui pautan anda, tanpa had!",
  cinema_loginForShareLink: "Log masuk untuk mendapatkan pautan kongsi anda",
  cinema_viewReferralStats: "Lihat Statistik Rujukan",
  cinema_episodeFinished: "Episod Selesai",
  cinema_unlockNextEpisode: "Buka Kunci Episod Seterusnya",
  cinema_changeDrama: "Tukar Video",
  cinema_allUnlocked: "Semua Dibuka",
  cinema_appDownloadButton: "Muat Turun Aplikasi",
  cinema_appDownloadUnavailable: "Muat turun masih belum tersedia",
  cinema_rechargeAppPromptTitle: "Muat turun Aplikasi untuk Syiling Bonus",
  cinema_rechargeAppPromptReward: "Muat turun dan log masuk untuk mendapatkan {{points}} syiling tambahan!",
  cinema_rechargeAppPromptDesc: "Nikmati pemutaran yang lebih boleh dipercayai dan kemajuan tontonan automatik dalam Aplikasi.",
  cinema_appDownloadQr: "Imbas untuk memuat turun Aplikasi",
  cinema_ageGateBadge: "Pengesahan umur",
  cinema_ageGateTitle: "Notis Kandungan Dewasa",
  cinema_ageGateDescription: "Laman web ini mengandungi kandungan fiksyen hasil janaan AI yang ditujukan hanya untuk orang dewasa. Dengan meneruskan, anda mengesahkan bahawa anda berumur sekurang-kurangnya 18 tahun dan bersetuju mematuhi undang-undang di lokasi anda.",
  cinema_ageGateUnderage: "Jika anda berumur bawah 18 tahun, sila tinggalkan laman web ini sekarang.",
  cinema_ageGateConfirm: "Saya berumur 18 tahun atau lebih tua — masuk ke laman web",
  cinema_creatorCenter: "Pusat Pencipta",
  cinema_creatorCenterDesc: "Cipta cerita anda, kongsi dunia anda",
  cinema_creatorCenterNote: "Nota: Karya bukan asal hendaklah bebas daripada cap air",
  cinema_creatorMemberReady: "Anda adalah ahli VIP, daftar dengan satu klik",
  cinema_creatorBecome: "Menjadi Pencipta",
  cinema_creatorGateDesc: "Bawa cerita anda ke Huangguo TV. Setelah disahkan, karya anda akan disiarkan di pawagam untuk jutaan penonton melihat bakat anda serta memperoleh bahagian pendapatan langganan premium.",
  cinema_creatorApplyBtn: "Mohon untuk Menjadi Pencipta",
  cinema_creatorBenefitTitle: "Faedah Pencipta",
  cinema_creatorBenefit1: "Karya anda akan disenaraikan dengan tag \"Asal\" khas",
  cinema_creatorBenefit2: "Lakukan pengesanan paparan, langganan dan bahagian pendapatan secara masa nyata",
  cinema_creatorBenefit3: "Buka kunci lebih banyak alat penciptaan dan sumber promosi",
  cinema_creatorReviewTip: "Permohonan dan karya akan dikaji oleh platform serta perlu mematuhi garis panduan komuniti.",
  cinema_creatorLevel: "Pencipta Disahkan",
  cinema_creatorOriginal: "Asal",
  cinema_creatorSince: "Pencipta sejak",
  cinema_creatorAddWork: "Muat Naik Karya Baharu",
  cinema_creatorTabOverview: "Gambaran Keseluruhan",
  cinema_creatorTabWorks: "Karya Saya",
  cinema_creatorTabUpload: "Muat Naik",
  cinema_creatorTabPlatform: "Studio",
  cinema_creatorSubmitted: "Dihantar, menunggu semakan",
  cinema_creatorStatViews: "Jumlah Tontonan",
  cinema_creatorStatSubs: "Jumlah Pelanggan",
  cinema_creatorStatRevenue: "Jumlah Pendapatan",
  cinema_creatorStatWithdraw: "Boleh Ditarik Balik",
  cinema_creatorStatWorks: "Karya",
  cinema_creatorStatReview: "Dalam Semakan",
  cinema_creatorStatRejected: "Ditolak",
  cinema_creatorTopWork: "Karya Paling Berprestasi",
  cinema_creatorViews: "Tontonan",
  cinema_creatorSubscriptions: "Pelanggan",
  cinema_creatorShare: "Pendapatan",
  cinema_creatorNoPublished: "Tiada karya diterbitkan lagi",
  cinema_creatorFilterPublished: "Diterbitkan",
  cinema_creatorFilterReview: "Dalam Semakan",
  cinema_creatorFilterRejected: "Ditolak",
  cinema_creatorWorksTitle: "Karya Saya",
  cinema_creatorNoWorks: "Tiada karya lagi, muat naik karya pertama anda",
  cinema_creatorGoUpload: "Muat Naik Sekarang",
  cinema_creatorStatusPublished: "Diterbitkan",
  cinema_creatorStatusReview: "Dalam Semakan",
  cinema_creatorStatusApproved: "Menunggu Transkod",
  cinema_creatorStatusTranscoding: "Sedang Transkod",
  cinema_creatorStatusReady: "Menunggu Penerbitan",
  cinema_creatorStatusTranscodeFailed: "Transkod Gagal",
  cinema_creatorStatusPublishFailed: "Penerbitan Gagal",
  cinema_creatorStatusRejected: "Ditolak",
  cinema_creatorPublishedOn: "Diterbitkan pada",
  cinema_creatorSubmittedOn: "Dihantar pada",
  cinema_creatorRejectedTip: "Ditolak · Dihantar pada",
  cinema_creatorWorkName: "Tajuk Karya",
  cinema_creatorWorkNamePh: "Masukkan tajuk karya",
  cinema_creatorCategory: "Kategori",
  cinema_creatorCover: "Sampul",
  cinema_creatorCoverHint: "Muat naik satu imej sampul potret",
  cinema_creatorCoverUrlPh: "Tampal pautan imej (pilihan)",
  cinema_creatorSynopsis: "Sinopsis",
  cinema_creatorSynopsisPh: "Nyatakan kisah anda dalam satu atau dua ayat…",
  cinema_creatorEpisodeTitle: "Episod",
  cinema_creatorEpisodeDesc: "Tambahkan tajuk dan muat naik satu video MP4 atau MOV untuk setiap episod",
  cinema_creatorEpisodeTitlePh: "Tajuk episod",
  cinema_creatorEpisodeDurPh: "Tempoh (minit)",
  cinema_creatorAddEpisode: "Tambah Episod",
  cinema_creatorEpShort: "Ep {{count}}",
  cinema_creatorEpisodeUpload: "Muat Naik Video",
  cinema_creatorEpisodeUploading: "Memuat naik…",
  cinema_creatorEpisodeReplace: "Gantikan video",
  cinema_creatorEpisodeMp4Only: "Fail .mp4 dan .mov, sehingga 100 MB setiap fail",
  cinema_creatorEpisodeTypeError: "Setiap episod mestilah berupa video .mp4 atau .mov",
  cinema_creatorEpisodeSizeError: "Video setiap episod tidak boleh melebihi saiz 100 MB",
  cinema_creatorEpisodeUploadFailed: "Muat naik episod gagal. Sila cuba lagi.",
  cinema_creatorEpisodeRequired: "Tambahkan tajuk dan muat naik video MP4 atau MOV untuk setiap episod",
  cinema_creatorRequired: "Sila isi tajuk dan pilih sampul terlebih dahulu",
  cinema_creatorWorkNameRequired: "Masukkan tajuk karya",
  cinema_creatorCategoryRequired: "Pilih kategori",
  cinema_creatorCoverRequired: "Muat naik imej sampul",
  cinema_creatorEpisodeTitleRequired: "Masukkan tajuk episod",
  cinema_creatorEpisodeVideoRequired: "Muat naik video MP4 atau MOV untuk episod ini",
  cinema_creatorSubmit: "Hantar untuk Semakan",
  cinema_creatorPlatformTag: "Disarankan oleh Pencipta",
  cinema_creatorPlatformTitle: "Platform Alat Penciptaan",
  cinema_creatorPlatformDesc: "Pergi ke platform penciptaan rasmi untuk alat profesional, inspirasi skrip dan aset bagi menghidupkan kisah anda serta menerbitkannya.",
  cinema_creatorPlatformPoint1: "Skrip & Idea AI",
  cinema_creatorPlatformPoint2: "Alat Penciptaan & Muat Naik Profesional",
  cinema_creatorPlatformPoint3: "Sokongan Trafik & Bayaran",
  cinema_creatorPlatformOpen: "Pergi ke Platform Penciptaan",
  cinema_creatorEarnBannerTitle: "Bawa Kisah Anda ke Pawagam",
  cinema_creatorEarnBannerDesc: "Jadi seorang pencipta, muat naik karya dan dapatkan pendapatan daripada tontonan, langganan serta perkongsian hasil",
  cinema_creatorEarnBannerBtn: "Buka Pusat Pencipta",
  cinema_creatorApplyFailed: "Permohonan gagal. Sila cuba lagi.",
  cinema_creatorSubmitFailed: "Penghantaran gagal. Sila cuba lagi.",
  cinema_creatorSubmitting: "Menghantar…",
  cinema_creatorCategoryEmpty: "Tiada kategori tersedia",
  cinema_creatorCoverUpload: "Muat naik sampul",
  cinema_creatorCoverUploading: "Memuat naik…",
  cinema_creatorCoverChoose: "Pilih imej",
  cinema_creatorCoverReplace: "Gantikan imej",
  cinema_creatorCoverRemove: "Padamkan",
  cinema_creatorCoverFormat: "JPG, PNG, WebP atau GIF, sehingga 10 MB. Hanya satu imej sahaja.",
  cinema_creatorCoverTypeError: "Pilih imej JPG, PNG, WebP atau GIF",
  cinema_creatorCoverSizeError: "Imej sampul tidak boleh melebihi 10 MB",
  cinema_creatorCoverUploadFailed: "Muat naik imej sampul gagal. Sila cuba lagi.",
  cinema_creatorUploadNoticeTitle: "Garis Panduan Muat Naik",
  cinema_creatorUploadNotice1: "Semua sumber yang dimuat naik, sama ada asal atau sebaliknya, hendaklah bebas daripada cap air.",
  cinema_creatorUploadNotice2: "Pencipta asal boleh menghubungi pasukan perniagaan kami untuk mendaftarkan hak cipta.",
  cinema_creatorUploadNotice3: "Harga episod akhir ditentukan oleh platform.",
  cinema_creatorUploadNotice4: "Setiap episod hendaklah mempunyai tempoh sekurang-kurangnya 150 saat.",
  cinema_creatorUploadNoticeConfirm: "Saya faham, teruskan",
  cinema_navProfile: "Saya",
};
